import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;
export default class ProductService {
  async getAllProductos(parametros) {
    const queryParams = parametros
      ? Object.keys(parametros)
          .map(
            (k) =>
              encodeURIComponent(k) + "=" + encodeURIComponent(parametros[k])
          )
          .join("&")
      : "";
    const productos = await fetchWrapper.get(`${ruta}/producto?` + queryParams);
    return productos;
  }

  async registrarProducto(producto) {
    return await fetchWrapper.post(`${ruta}/producto`, producto);
  }

  async actualizarProducto(producto) {
    return await fetchWrapper.put(`${ruta}/producto/` + producto.id, producto);
  }
  async showProducto(producto) {
    const ProductoShow = await fetchWrapper.get(`${ruta}/producto/` + producto);
    return ProductoShow;
  }

  // [2026-10] CAMBIO: updateCell acepta `opciones` (p. ej. { aplicar_todas_sucursales: true }) y no envía sucursal_id si es null.
  // MOTIVO: la lista guarda el precio en todas las sucursales activas con un solo envío. Sin `opciones` el comportamiento es el
  // de siempre (fetchWrapper.post, rechaza con un string). Con `opciones` se usa fetchWrapper.raw para conservar `errors` del 422:
  // rechaza con { status, message, errors } (message = primer mensaje de errors) y trata {autorizado:false} y {success:false}
  // como error. Nota: raw no cierra la sesión en un 401 (aquí solo se informa el error).
  // REF: docs_trabajo/resultado_celda_frontend.md
  async updateCell(id, field, value, sucursal_id, opciones = null) {
    const cuerpo = { field: field, value: value };
    if (sucursal_id !== null && sucursal_id !== undefined) cuerpo.sucursal_id = sucursal_id;
    if (!opciones) return await fetchWrapper.post(`${ruta}/producto/${id}/update-cell`, cuerpo);

    const { ok, status, data } = await fetchWrapper.raw("POST", `${ruta}/producto/${id}/update-cell`, { ...cuerpo, ...opciones });
    if (status === 0) throw { status, message: "No se pudo conectar con el servidor." };
    if (!ok) {
      const errores = data && typeof data === "object" ? data.errors : null;
      const primero = errores ? Object.values(errores).flat()[0] : null;
      throw {
        status,
        message: primero || (data && data.message) || `Error ${status} del servidor.`,
        errors: errores || null,
      };
    }
    if (data && data.autorizado === false) {
      throw { status, message: data.message || "No tiene permiso para editar precios." };
    }
    if (!data || data.success !== true) {
      throw { status, message: (data && data.message) || "No se pudo guardar el precio." };
    }
    return data;
  }

  async deleteProducto(producto) {
    const deleteProd = await fetchWrapper.delete(
      `${ruta}/producto/` + producto.id
    );
    return deleteProd;
  }

  async buscarXNombre(datos) {
    return await fetchWrapper.post(`${ruta}/producto/buscar`, datos);
  }
  async buscarXNombreVenta(datos) {
    return await fetchWrapper.post(`${ruta}/producto/buscar_para_venta`, datos);
  }

  async buscarXCodigoBarra(datos) {
    return await fetchWrapper.post(`${ruta}/producto_cod_barra/buscar`, datos);
  }
  async importarProductos(productos) {
    return await fetchWrapper.postFiles(`${ruta}/productos-import`, productos);
  }
  async importarPaquete(productos) {
    return await fetchWrapper.postFiles(`${ruta}/paquete-import`, productos);
  }
  async filtrarProductos(datos) {
    return await fetchWrapper.post(`${ruta}/filtros_producto`, datos);
  }
  async imprimirPDF(datos) {
    return await fetchWrapper.postPdf(
      `${ruta}/reporte/producto/imprimir`,
      datos
    );
  }
  async exportarProductos(datos) {
    const exportado = await fetchWrapper.postWithBlob(
      `${ruta}/productos-export`,
      datos
    );
    return exportado;
  }

  async getProductos_fecha_vence() {
    return await fetchWrapper.get(`${ruta}/productos_fecha_vence`);
  }

  async filtrarFechaVence(datos) {
    return await fetchWrapper.post(`${ruta}/filtros_fecha_vence`, datos);
  }

  async printRFechaVence(datos) {
    return await fetchWrapper.postPdf(
      `${ruta}/reporte/producto_fecha_vence/imprimir`,
      datos
    );
  }

  async exportFechaVence(datos) {
    const exportado = await fetchWrapper.postWithBlob(
      `${ruta}/productos_fecha_vence_export`,
      datos
    );
    return exportado;
  }

  async getProductos_stock_minimo() {
    return await fetchWrapper.get(`${ruta}/productos_stock_minimo`);
  }

  async buscar_x_codigo_nombre(datos) {
    return await fetchWrapper.post(
      `${ruta}/producto/buscar_x_codigo_nombre`,
      datos
    );
  }

  async getProductoSucursal(datos) {
    return await fetchWrapper.post(`${ruta}/producto_sucursal`, datos);
  }

  async sincronizarSIN() {
    return await fetchWrapper.post(`${ruta}/sincronizarSIN`);
  }
  async getCodigoSIN() {
    return await fetchWrapper.get(`${ruta}/productos-codigo-sin`);
  }

  async getDatosNecesariosProducto() {
    return await fetchWrapper.post(`${ruta}/producto/datos-necesarios`);
  }
  async getProductoImages(producto_id) {
    return await fetchWrapper.post(`${ruta}/producto/${producto_id}/images`);
  }
  async uploadImage(datos) {
    return await fetchWrapper.postFiles(
      `${ruta}/producto/images/upload`,
      datos
    );
  }

  async deleteImage(imagen_id) {
    return await fetchWrapper.delete(`${ruta}/producto/images/${imagen_id}`);
  }

  async buscarLaboratorioXNombre(datos) {
    return await fetchWrapper.post(`${ruta}/laboratorio/buscar`, datos);
  }

  async getBordes(sucursal_id) {
    return await fetchWrapper.get(`${ruta}/producto/bordes?sucursal_id=${sucursal_id}`);
  }

  /***
   * Obtiene los extras en pos
   * @param {*} sucursal_id 
   * @returns 
   */
  async getExtras(sucursal_id) {
    return await fetchWrapper.get(`${ruta}/producto/extras?sucursal_id=${sucursal_id}`);
  }

  /**
   * Obtiene los productos id y name
   */
  async getProductosCombo(tipo_catalogo = null, extraParams = {}) {
    const params = { ...extraParams };
    if (tipo_catalogo) params.tipo_catalogo = tipo_catalogo;
    
    // Eliminar valores nulos o indefinidos
    Object.keys(params).forEach(key => (params[key] == null || params[key] === '') && delete params[key]);
    
    const queryParams = new URLSearchParams(params).toString();
    const query = queryParams ? `?${queryParams}` : '';
    return await fetchWrapper.get(`${ruta}/producto/getProductoCombo${query}`);
  }
  async getLotesDisponibles(producto_id, sucursal_id) {
    return await fetchWrapper.get(`${ruta}/producto/${producto_id}/lotes_disponibles?sucursal_id=${sucursal_id}`);
  }
}